import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { getActiveUsersSummary } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetActiveUsersSummaryResponse,
	GetActiveUsersSummaryRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetActiveUsersSummary(
	payload?: GetActiveUsersSummaryRequest,
	options?: Omit<
		UseQueryOptions<GetActiveUsersSummaryResponse>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery<GetActiveUsersSummaryResponse>({
		queryKey: [DashboardKeys.ActiveUsersSummary, payload],
		queryFn: () => getActiveUsersSummary(payload),
		...options,
	})
}
